// utils/mediaUtils.js
export function isVideoFile(url) {
  if (!url) return false;

  try {
    const cleanUrl = new URL(url).pathname;

    const ext = cleanUrl.split('.').pop().toLowerCase();

    const videoExtensions = ['mp4', 'mov', 'avi', 'webm', 'mkv'];

    return videoExtensions.includes(ext);
  } catch (error) {
    console.error("Invalid URL:", url);
    return false;
  }
}

export function base64ToBlob(base64, mimeType = '') {
  const byteChars = atob(base64);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}